import React, {useContext, useEffect, useState} from 'react';
import {enrichProductsWithOutSystemData, mapProductToCardData} from '../ProductCard/ProductCard.helper';
import {ProductCard} from '../ProductCard/ProductCard';
import {ProductCardSlider} from '../ProductCard/ProductCardsSlider';
import {getProductRecommendations as getAlsoBoughtProducts} from '../../../../api/ECOM/​getProductRecommendations.api';
import {ProductContext} from '../../../pages/ProductStencil';
import {AnonProducts, Products} from "../../../../interfaces/ecom/schema";
import {useI18N} from "../../../my-puratos/hoc/withI18N";
import {CardSliderSkeleton} from "../../../atoms/effects/skeletons/product-stencil/CardSliderSkeleton";
import {GA4ComponentType} from "../../../../analytics/ga4/types/component";

export const AlsoBought = ({isCarousel = true}) => {
    const translate = useI18N();
    const productData = useContext(ProductContext);
    const [alsoBoughtProducts, setAlsoBoughtProducts] = useState<Products | AnonProducts>({Products: []});
    const [isDataLoading, setIsDataLoading] = useState(true);

    useEffect(() => {
        if (productData.alsoBoughtProducts.Products.length) {
            setAlsoBoughtProducts(productData.alsoBoughtProducts);
            setIsDataLoading(false);
            return;
        }
        const fetchAlsoBought = async () => {
            try {
                const {Products} = await getAlsoBoughtProducts({AEMProductID: productData.product.id});
                if (Products.length) {
                    const updatedProducts = await enrichProductsWithOutSystemData([...Products].splice(0, 12));
                    setAlsoBoughtProducts({Products: updatedProducts});
                    productData.setAlsoBoughtProducts({Products: updatedProducts});
                }
            } catch (error) {
                console.error(error);
            } finally {
                setIsDataLoading(false);
            }
        };

        fetchAlsoBought();
    }, [productData]);

    if (isDataLoading) {
        return (<CardSliderSkeleton/>);
    }

    if (!alsoBoughtProducts.Products.length) {
        return null;
    }

    const renditionFallback = productData.product.renditionFallback;
    const renderedProductCards = alsoBoughtProducts.Products.map((product, index) => (
        <ProductCard data={mapProductToCardData(product, renditionFallback, GA4ComponentType.PDP_ALSO_BOUGHT)}
                     key={index}/>
    ));

    return (
        <div className="pdp-section__container">
            {isCarousel ? (
                <ProductCardSlider title={translate('Customers also bought')}>
                    {renderedProductCards}
                </ProductCardSlider>
            ) : (
                <div className={'product-cards__container'}>
                    {renderedProductCards.slice(0, 10)}
                </div>
            )}
        </div>
    );
};

export default AlsoBought;